import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { ArrowLeftOutlined, EyeTwoTone } from "@ant-design/icons";
import { Image, Input, Modal } from "antd";
import { useMutation } from "react-query";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import Auth from "../../lib/middleware/auth";
import { inputStyle } from "../../lib/styles/styleLibrary";
import { setPin, viewUserProfile } from "../../redux/actions/authentication";
import errorHandler from "../../redux/actions/errorHandler";
import { Loading } from "../Loading/Loading";
import lock from "../../assets/svg/lock_red.svg";
import pwd_hidden from "../../assets/svg/pwd_hidden_eye.svg";
import { Wrapper } from "./component";
import PropTypes from "prop-types";

const PinSetup = ({
	isTransactionPin,
	setTransactionPin = () => {
		return null;
	},
	pinData,
}) => {
	const user = Auth.getUser();
	const [tp, setTP] = useState(false);
	const [walletPin, setWalletPin] = useState({
		email: user?.email,
		old_pin: "",
		confirm_new_pin: "",
	});

	useEffect(() => {
		if (!isEmpty(pinData)) {
			tp && handleWalletPin();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pinData, tp]);

	const { mutateAsync: handleSetPin, isLoading: setPinLoading } =
		useMutation(setPin);

	const handleWalletPin = async () => {
		if (isEmpty(pinData)) {
			if (
				isEmpty(walletPin.old_pin) ||
				isEmpty(walletPin.confirm_new_pin)
			) {
				Toast.fire({
					icon: "error",
					title: `Pin cannot be empty`,
				});
				return;
			}
			if (walletPin.old_pin !== walletPin.confirm_new_pin) {
				Toast.fire({
					icon: "error",
					title: `Pins do not match`,
				});
				return;
			}
		}

		const data = {
			pin: walletPin.old_pin || pinData,
		};

		try {
			const res = await handleSetPin(data);
			console.log(res);
			const { hasError, errors } = res.data;
			if (hasError) {
				return errorHandler(errors);
			}
			Toast.fire({
				icon: "success",
				title: `${res.data.message}\n ${res.data.data}`,
			});
			viewUserProfile();
			setTransactionPin(false);
		} catch (err) {
			console.log("the set pin error", err);
		}
	};

	return (
		<Wrapper>
			<Modal
				footer=""
				visible={isTransactionPin}
				centered
				onCancel={() => setTransactionPin(false)}
				maskClosable={false}>
				<div
					tw="mb-4 h-8 w-8 px-2 py-2 bg-gray-100 rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800) flex flex-col items-center justify-center"
					onClick={() => setTransactionPin(false)}>
					<ArrowLeftOutlined tw="hover:(text-purple-800 transform scale-125)" />
				</div>
				<div tw="mt-4 mb-4!">
					<label htmlFor="name" className="label">
						Wallet PIN
					</label>
					<div tw="mt-4">
						<Input.Password
							placeholder="Enter wallet PIN"
							type="password"
							css={inputStyle}
							value={walletPin.old_pin}
							onChange={(e) => {
								setWalletPin({
									...walletPin,
									old_pin: e.target.value.trim(),
								});
							}}
							prefix={<img src={lock} alt="" tw="pr-2" />}
							iconRender={(visible) =>
								visible ? (
									<EyeTwoTone twoToneColor="#9797BD" />
								) : (
									<Image
										preview={false}
										src={pwd_hidden}
										alt=""
										width={20}
										height={20}
									/>
								)
							}
						/>
					</div>

					<label htmlFor="name" className="label">
						Confirm Wallet PIN
					</label>
					<div tw="mt-4">
						<Input.Password
							placeholder="Confirm Wallet PIN"
							type="password"
							css={inputStyle}
							value={walletPin.confirm_new_pin}
							onChange={(e) => {
								setWalletPin({
									...walletPin,
									confirm_new_pin: e.target.value.trim(),
								});
							}}
							prefix={<img src={lock} alt="" tw="pr-2" />}
							iconRender={(visible) =>
								visible ? (
									<EyeTwoTone twoToneColor="#9797BD" />
								) : (
									<Image
										preview={false}
										src={pwd_hidden}
										alt=""
										width={20}
										height={20}
									/>
								)
							}
						/>
					</div>

					<div tw="flex justify-center items-center w-full mt-4">
						<button
							onClick={() => {
								setTimeout(() => {
									setTP(true);
								}, 200);
								handleWalletPin();
							}}
							tw="bg-appLightPink w-full text-appPink rounded-2xl font-semibold px-3 py-2 border-none hover:(shadow-md text-appPinkSaturated font-bold cursor-pointer)">
							{setPinLoading ? <Loading /> : "Set wallet pin"}
						</button>
					</div>
				</div>
			</Modal>
		</Wrapper>
	);
};

PinSetup.propTypes = {
	pinData: PropTypes.string,
};

PinSetup.defaultProps = {
	pinData: "",
};

export default PinSetup;
